import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {
    ICustomerPortalService,
    IFalconConvenienceApiService,
    Policy,
    ProductsEnum,
    resourcesHelper,
    Types
} from "@falcon/services";
import FalconHeader from "../components/navigation/FalconHeader";
import FalconFooter from "../components/navigation/FalconFooter";

interface IProps extends RouteComponentProps<{}> {
}

interface IState {
    accountUrl: string,
    wording: string
}

@authorize
export class EventWarningPage extends React.Component<IProps, IState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.FalconConvenienceApiService)
    private falconConvenienceApiService: IFalconConvenienceApiService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            accountUrl: "",
            wording: ""
        }
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Warning");

        this.customerPortalService.getUserPoliciesWithLatestVersions()
            .subscribe((policies: Policy[]) => {
                this.falconConvenienceApiService.getSettings().subscribe(settings => {
                    let wording: string = "";
                    let accountUrl: string = "/dashboard";
                    policies.forEach(p => {
                        if (p.products.includes(ProductsEnum.WOLF_MOTOR)) {
                            wording = settings?.eventWarningPage?.motor?.wording;
                        } else if (p.products.includes(ProductsEnum.HOME)) {
                            wording = settings?.eventWarningPage?.home?.wording;
                        }
                    });

                    if (policies?.length > 1) {
                        accountUrl = "dashboard/multiPolicy/account";
                    }
                    this.setState({accountUrl, wording});
                });

            });
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>

                <div className="event-warning-page">
                    <div className="logo-container">
                        <img className="event-warning-icon"
                             src={`/${resourcesHelper.THEME}/img/large-allianz-bottom-logo.svg`}
                             alt="Allianz logo"/>
                    </div>
                    <div className="content-container">
                        <img className="main-icon maintenance-icon mb-2"
                             src={`/${resourcesHelper.THEME}/img/Flourish-error.svg`}
                             alt="Error"/>
                        <div>
                            <p className="content-header">
                                Important message
                            </p>
                            <div className="wording-container">
                                <p>
                                    We're having an issue that means you won't currently be able to {this.state.wording}.
                                </p>
                                <p>
                                    We're getting this fixed as quickly as we can. If you need help today, please use
                                    Live Chat or {' '}
                                    <a className="text-decoration-underline muli-bold-16"
                                       href={`mailto:${resourcesHelper.HELP_EMAIL}`} target="_blank"
                                       id="complaintsEmail">email</a>.
                                </p>
                                <p>
                                    Nothing else has been affected.
                                    Sorry for the inconvenience.
                                </p>
                            </div>
                        </div>
                        <div className="continue-button-container px-4 px-md-0 padding-left-right-0-mb">
                            <button type="button" className="btn btn-primary btn-add plugin mt-3"
                                    id="next"
                                    disabled={false}
                                    onClick={this.redirect}>Continue to my account
                            </button>
                        </div>
                    </div>
                </div>

                <FalconFooter/>
            </React.Fragment>
        )
    }

    private redirect = (): void => {
        this.props.history.push(this.state.accountUrl);
    };
}



// WEBPACK FOOTER //
// ./src/pages/EventWarningPage.tsx